module.exports = __webpack_public_path__ + "img/financial.0c432235.jpg";